import RegionCardsCarouselConnect, {
  RegionCardsCarouselConnectProps,
  RegionCardType
} from './RegionCardsCarouselConnect'

export { RegionCardsCarouselConnect }
export type { RegionCardsCarouselConnectProps, RegionCardType }
